import React from 'react'
import HeaderMoves from "./header/HeaderMoves"
import HeaderButtons from './header/HeaderButtons'
import DataPicture from "./data/DataPicture"
import MoveList from "./moves/MoveList"
import LoginButtons from "./header/login/LoginButtons"

export default function container3({ section, apiData, localData, state, setSection, moves}) {

  return (
    <>
      <div className="container violet-bg">
        <header>
          <HeaderMoves />
          <HeaderButtons section={section} setSection={setSection} />
          <LoginButtons></LoginButtons>
        </header>
        <div className="pokemon-moves-container">
            <DataPicture apiData={apiData} localData={localData} state={state} section={section}></DataPicture>
            <MoveList apiData={apiData} localData={localData} moves={moves}></MoveList>
        </div>
      </div>
    </>
  )
}
